/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Members_CountInputs */

const en_members_count = /** @type {(inputs: Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} members`)
};

const es_members_count = /** @type {(inputs: Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} miembros`)
};

const fr_members_count = /** @type {(inputs: Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} membres`)
};

const de_members_count = /** @type {(inputs: Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Mitglieder`)
};

const id_members_count = /** @type {(inputs: Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} anggota`)
};

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const ja_members_count = en_members_count;

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const zh_members_count = en_members_count;

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const ar_members_count = en_members_count;

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const it_members_count = en_members_count;

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const ru_members_count = en_members_count;

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const pt_members_count = en_members_count;

/** @type {(inputs: Members_CountInputs) => LocalizedString} */
const ko_members_count = en_members_count;

/**
* | output |
* | --- |
* | "{count} members" |
*
* @param {Members_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const members_count = /** @type {((inputs: Members_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_members_count(inputs)
	if (locale === "es") return es_members_count(inputs)
	if (locale === "fr") return fr_members_count(inputs)
	if (locale === "de") return de_members_count(inputs)
	if (locale === "ja") return ja_members_count(inputs)
	if (locale === "zh") return zh_members_count(inputs)
	if (locale === "ar") return ar_members_count(inputs)
	if (locale === "id") return id_members_count(inputs)
	if (locale === "it") return it_members_count(inputs)
	if (locale === "ru") return ru_members_count(inputs)
	if (locale === "pt") return pt_members_count(inputs)
	return ko_members_count(inputs)
});